// src/components/Navbar.jsx
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.logo}>
        <span style={styles.logoIcon}>🐱</span>
        <span style={styles.logoText}>Purrfect<em style={{color:"var(--rust)",fontStyle:"italic"}}>Match</em></span>
      </Link>

      <div style={styles.links}>
        <Link to="/"          style={{...styles.link, ...(pathname==="/"         ? styles.active:{})}}>Browse Cats</Link>
        <Link to="/submit"    style={{...styles.link, ...(pathname==="/submit"   ? styles.active:{})}}>Rehome a Cat</Link>
        <Link to="/dashboard" style={{...styles.link, ...(pathname==="/dashboard"? styles.active:{})}}>My Listings</Link>
        <Link to="/login"     style={styles.loginBtn}>Owner Login</Link>
      </div>

      {/* Mobile */}
      <button style={styles.burger} onClick={()=>setOpen(!open)}>☰</button>
      {open && (
        <div style={styles.mobileMenu}>
          {[["/ ","Browse Cats"],["/submit","Rehome a Cat"],["/dashboard","My Listings"],["/login","Login"]].map(([to,label])=>(
            <Link key={to} to={to.trim()} style={styles.mobileLink} onClick={()=>setOpen(false)}>{label}</Link>
          ))}
        </div>
      )}
    </nav>
  );
}

const styles = {
  nav: {
    position:"sticky", top:0, zIndex:100,
    background:"rgba(253,247,240,0.92)", backdropFilter:"blur(12px)",
    borderBottom:"1px solid rgba(192,98,42,0.1)",
    padding:"0 32px", height:68,
    display:"flex", alignItems:"center", justifyContent:"space-between",
    fontFamily:"'Outfit',sans-serif",
  },
  logo: { display:"flex", alignItems:"center", gap:10, textDecoration:"none" },
  logoIcon: { fontSize:26 },
  logoText: { fontFamily:"'Playfair Display',serif", fontSize:22, color:"var(--deep)", fontWeight:700 },
  links: { display:"flex", alignItems:"center", gap:28, "@media(max-width:640px)":{display:"none"} },
  link: { fontSize:15, color:"var(--muted)", fontWeight:500, transition:"color 0.2s", textDecoration:"none" },
  active: { color:"var(--rust)" },
  loginBtn: {
    background:"var(--rust)", color:"#fff", padding:"8px 20px",
    borderRadius:50, fontSize:14, fontWeight:500, textDecoration:"none",
    transition:"all 0.2s",
  },
  burger: { display:"none", background:"none", border:"none", fontSize:22, cursor:"pointer", color:"var(--deep)" },
  mobileMenu: {
    position:"absolute", top:68, left:0, right:0,
    background:"var(--cream)", borderBottom:"1px solid var(--peach)",
    padding:"12px 0", display:"flex", flexDirection:"column",
  },
  mobileLink: { padding:"12px 32px", fontSize:16, color:"var(--text)", textDecoration:"none" },
};
